module.exports = __webpack_public_path__ + "assets/img/67_725_4.35e9f3fe.jpg";